import React, { useEffect, useState } from 'react'
import Header from '../../components/Header.jsx'
import SearchInput from '../../components/SearchInput.jsx'
import { authAxios } from '../../helpers/axios.js'
import { toast } from 'react-toastify'
import Popup from '../../components/Popup.jsx'
import Input from '../../components/Input.jsx'
import FilterSelect from '../../components/FilterSelect.jsx'
import Select from '../../components/Select.jsx'
import Map from '../../components/Map.jsx'
import { Link, useNavigate } from 'react-router-dom'
import ManageSupplier from './components/ManageGarden.jsx'
import { getBase64Image } from '../../helpers/helpers.js'
import DefaultImage from '../../images/image.svg'
import { InfoToast } from '../../helpers/toasters.js'
import RetailerFilter from './components/RetailerFilter.jsx'
import { LIMIT } from '../../helpers/constants.js'
import SortIcon from '../../images/sort.svg'
import RightIcon from '../../images/right.svg'
import FilterIcon from '../../images/filter.svg'
import FilterActiveIcon from '../../images/filteractive.svg'
import { findCountryByCode } from '../../helpers/utils.js'

export default function Garden() {

    const [searchText,setSearchText] = useState('')
    const [gardens,setGardens] = useState([])
    const [showCreate,setShowCreate] = useState({status:false,edit:null})
    const [exporting,setExporting] = useState(false)
    const navigate = useNavigate()

    const [cityFilters,setCityFilters] = useState([])
    const [routeFilters,setRouteFilters] = useState([])

    const [offset,setOffset] = useState(0);
    const [count,setCount] = useState(0)

    const [filters,setFilters] = useState({routeId:null,cityId:null,status:null})
    const [showFilters,setShowFilters] = useState(false)
    const [sort,setSort] = useState('name');
    
    const onFilterSubmit = (filters)=>
    {
        try 
        {
            setFilters({...filters})
            setCount(5)
            setOffset(0)
            setShowFilters(false)
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const clearFilter = ()=>
    {
        try 
        {
            setFilters({routeId:null,cityId:null,status:null,distributorId:null,retailerId:null,teamId:null,salesRepId:null,startDate:null,endDate:null})
            setShowFilters(false)
        } catch (error) {
            toast('Order Filtered')
        }
    }

    const onSortPress = (type)=>
    {
        if (sort === type) {
            if(sort === `-${type}`) setSort(type)
            else setSort(`-${type}`);
          } else {
            setSort(type);
          }
    }
    
    async function getGardens(){

        try 
        {
            let query = `&limit=${LIMIT}&offset=${offset}&orderBy=${sort}`;
                if(searchText) query+= `&searchText=${searchText}`;
                if(filters.cityId) query+=`&cityId=${filters.cityId.id}`
                if(filters.status) query+=`&status=${filters.status}`
            let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/garden?populate=true${query}`)
            if(res.data.data) 
            {
                setGardens(res.data.data)
                setCount(res.data.count)
            }
        } catch (error) {
            console.log(error)
            toast('Error getting gardens')
        }
    }

    useEffect(()=>
    {
        getGardens()
    },[filters,searchText,offset,sort])

    const RightContent = ()=>
    {
        return <div>
          {/* <button type='button' disabled={exporting} className='btn-md mr-4' onClick={()=>exportgardens()}>{exporting ? 'Exporting...' : 'Export'}</button> */}
          <button type='button' className='btn-md' onClick={()=>setShowCreate({status:true,edit:null})}>Create Garden</button>
        </div>
    }

    const onSubmit = async(e,data)=>
    {
        try 
        {
            e.preventDefault()

            // let imageRes;
            // if(croppedImage)
            // {
            //     let formData = new FormData();
            //     formData.append('image',croppedImage)
            //     imageRes = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/image`,formData,{                headers: {
            // 'content-type': 'multipart/form-data'}})
            // } 

            let res;
            if(showCreate.edit)
            {
                // let updateData = croppedImage ? {...data,retailerImage:imageRes.data.data} : {...data};
                InfoToast('Garden Updated')
                res = await authAxios.put(`${process.env.REACT_APP_BASE_URL}/garden/${showCreate.edit}`,DataTransfer); 
            }
            else
            {
                // let createData = croppedImage ? {...data,retailerImage:imageRes.data.data} : {...data};
                res = await authAxios.post(`${process.env.REACT_APP_BASE_URL}/garden`,data)
                InfoToast('Garden Created')
            }
            if(res.data)
            {
                await getGardens()
                setShowCreate({status:false,edit:null})
            }
            else toast('error updating garden')
        } catch (error) {
            console.log(error)
            toast(error.response)
        }
    }


  return (
    <>
        <Header title={'Gardens Management'} RightContent={RightContent}/>
        <div className='flex justify-between items-stretch border-b border-[#e3e3e3] bg-white'>
        <div className='flex'>
                <SearchInput value={searchText} setValue={(value)=>setSearchText(value)} placeholder={'Search Garden'} label={'Search Garden'} />
            <div className='flex w-full border-r items-center h-full justify-center text-center'>
                    <div className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center' onClick={()=>{if (offset > 0) {
                            setOffset(offset - LIMIT);
                        }}}>
                        <img src={RightIcon} className='w-[20px] h-[20px] rotate-180'/>
                    </div>
                    <p className='text-xs whitespace-nowrap w-[80px] justify-center'>{offset + 1}-{Math.min(offset + LIMIT, count)} of {count}</p>
                    <div className='px-2 hover:bg-[#f6f6f6] h-full cursor-pointer flex items-center flex-1 justify-center' onClick={()=>{if (offset + LIMIT < count) {
                            setOffset(offset + LIMIT);
                        }}}>
                        <img src={RightIcon} className='w-[20px] h-[20px]'/>
                    </div>
                </div>
                </div>
                <div className='flex justify-end h-[100%] self-stretch items-center px-4 border-l border-[#e3e3e3] hover:bg-[#f6f6f6] cursor-pointer' onClick={()=>setShowFilters(true)}>
            {(filters.cityId || filters.routeId || filters.status) ? <img src={FilterActiveIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> : <img src={FilterIcon} className={`w-[24px] h-[24px]`} alt='Filter' /> }
            </div>
        </div>
        <div className='flex-1 bg-white w-full flex overflow-scroll'>
            <table className='table-auto w-full flex-1'>
                <thead className='bg-[#f9f9f9] w-full'>
                    <tr className='w-full'>
                    <td><p onClick={()=>onSortPress('name')} className='cursor-pointer flex items-center hover:text-black'>Garden Name{sort === 'name' || sort === '-name'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('phone')} className='cursor-pointer flex items-center hover:text-black'>Phone/Email{sort === 'phone' || sort === '-phone'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('city')} className='cursor-pointer flex items-center hover:text-black'>Country{sort === 'city' || sort === '-city'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    <td><p onClick={()=>onSortPress('status')} className='cursor-pointer flex items-center hover:text-black'>Status{sort === 'status' || sort === '-status'? sort.charAt(0)==='-' ? <img src={SortIcon} className='rotate-[180deg] h-[16px] w-[16px] ml-1'/> : <img src={SortIcon} className='h-[16px] w-[16px] ml-1'/> : null}</p></td>
                    </tr>
                </thead>
                <tbody>
                    {
                        gardens.map((item,index)=>
                        {
                            return <Link to={`/gardens/${item.id}`} key={index}> 
                                <tr> 
                                <td className='capitalize'>
                                    <div className='flex'>
                                    {/* <div className='bg-gray-200 rounded-full w-[52px] h-[52px] mr-4'>
                                        <img src={item.retailerImage ? item.retailerImage : DefaultImage} className='w-[52px] h-[52px] rounded-full'/>
                                    </div> */}
                                    <div>
                                        <p className='text-sm font-medium my-0'>{item.name}</p>
                                    </div>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.contactNumber}</p>
                                        <p className='text-[13px] text-gray-400 my-0 lowercase'>{item.contactEmail}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className='text-sm font-medium my-0'>{item.city}</p>
                                    </div>
                                </td>
                                <td className='capitalize'>
                                <div>
                                        <p className={`text-[13px] font-medium px-3 inline-block py-1 rounded-md ${parseInt(item.status) ===  1 ? 'bg-[#39C7A5] bg-opacity-50 text-green-700 ' : 'text-red-700 bg-red-200 bg-opacity-10'}}`}>{parseInt(item.status) ===  1 ? 'Active' : 'Inactive'}</p>
                                    </div>
                                </td>
                                </tr>
                            </Link>
                        })
                    }
                </tbody>
            </table>
        </div>
        { showCreate.status ? <ManageSupplier onClose={setShowCreate} onSubmit={onSubmit} edit={showCreate.edit}/> : null}
        { showFilters ? <RetailerFilter onSubmit={onFilterSubmit} filters={filters} onClose={setShowFilters} clearFilter={clearFilter}/> : null}
    </>
  )
}

